import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  container: {
    base: {
      padding: theme.settings.spacing.large,
      borderRadius: theme.settings.borderRadiuses.regular,
      marginBottom: theme.settings.spacing.large,
      color: theme.colors.text.normal,
      flex: 1,
      borderWidth: '0px',
      borderStyle: 'solid',
    },

    flush: {
      marginBottom: 0,
    },

    variants: {
      primary: {
        backgroundColor: theme.colors.backgrounds.primary,
        borderColor: theme.colors.accents.primaryBorder,
      },

      secondary: {
        backgroundColor: theme.colors.backgrounds.secondary,
        borderColor: theme.colors.accents.secondaryBorder,
      },

      positive: {
        backgroundColor: theme.colors.backgrounds.positive,
        borderColor: theme.colors.accents.positiveBorder,
      },

      negative: {
        backgroundColor: theme.colors.backgrounds.negative,
        borderColor: theme.colors.accents.negativeBorder,
      },

      alert: {
        backgroundColor: theme.colors.backgrounds.alert,
        borderColor: theme.colors.accents.alertBorder,
      },

      cta: {
        backgroundColor: theme.colors.backgrounds.cta,
        borderColor: theme.colors.accents.ctaBorder,
      },

      brand: {
        backgroundColor: theme.colors.backgrounds.brand,
        borderColor: theme.colors.accents.brandBorder,
      },

      clear: {
        backgroundColor: 'transparent',
        borderColor: theme.colors.borders.dim,
      },
    },

    border: {
      borderWidth: '1px',
    },
  },

  icon: {
    variants: {
      primary: {
        color: theme.colors.accents.primary,
      },

      secondary: {
        color: theme.colors.accents.secondary,
      },

      positive: {
        color: theme.colors.accents.positive,
      },

      negative: {
        color: theme.colors.accents.negative,
      },

      alert: {
        color: theme.colors.accents.alert,
      },

      clear: {
        color: theme.colors.text.dimmed,
      },
    },
  },

  title: {
    base: {
      ...theme.typography.body,
      fontWeight: theme.settings.typography.weights.semibold,
      marginBottom: 0,
    },
  },

  description: {
    base: {
      ...theme.typography.body,

      ':not(:last-child)': {
        marginBottom: theme.settings.spacing.large,
      },
    },
  },
})
